import axios from 'axios'

export const v3_login = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/login`;
    return axios.post(url,model).then((res) => {
        return res.data;
    })

}